import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CharacterItem = ({ item }) => {
  const [queryName, setQueryName] = useState("");

  useEffect(() => {
    const kamalName = item.name.replace(" ", "+");

    setQueryName(kamalName);
  }, [item]);

  return (
    <div className="card">
      <div className="card-inner">
        <div className="card-front">
          <img src={item.img} alt="" />
        </div>
        <div className="card-back">
          <h1>{item.name}</h1>
          <ul>
            <li>
              <strong>Actor Name:</strong> {item.portrayed}
            </li>
            <li>
              <strong>Nickname:</strong> {item.nickname}
            </li>
            <li>
              <strong>Birthday:</strong> {item.birthday}
            </li>
            <li>
              <strong>Status:</strong> {item.status}
            </li>
          </ul>
          <div
            style={{
              paddingTop: "10px",
              textDecoration: "underline",
            }}
          >
            <Link to={`/character/${queryName}`} style={{ color: "white" }}>
              See {item.name}'s complete profile
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CharacterItem;
